import React from 'react';
// import PropTypes from 'prop-types';

const CalendarIcon = ({ fill }) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='17' height='17' viewBox='0 0 17 17' fill='none'>
            <path d='M14.8086 1.32812H13.2812V0.53125C13.2812 0.237867 13.0434 0 12.75 0C12.4566 0 12.2188 0.237867 12.2188 0.53125V1.32812H4.78125V0.53125C4.78125 0.237867 4.54342 0 4.25 0C3.95658 0 3.71875 0.237867 3.71875 0.53125V1.32812H2.19141C0.983045 1.32812 0 2.31117 0 3.51953V14.8086C0 16.017 0.983045 17 2.19141 17H14.8086C16.017 17 17 16.017 17 14.8086V3.51953C17 2.31117 16.017 1.32812 14.8086 1.32812ZM2.19141 2.39062H3.71875V2.92188C3.71875 3.21526 3.95658 3.45312 4.25 3.45312C4.54342 3.45312 4.78125 3.21526 4.78125 2.92188V2.39062H12.2188V2.92188C12.2188 3.21526 12.4566 3.45312 12.75 3.45312C13.0434 3.45312 13.2812 3.21526 13.2812 2.92188V2.39062H14.8086C15.4311 2.39062 15.9375 2.89704 15.9375 3.51953V4.78125H1.0625V3.51953C1.0625 2.89704 1.56891 2.39062 2.19141 2.39062ZM14.8086 15.9375H2.19141C1.56891 15.9375 1.0625 15.4311 1.0625 14.8086V5.84375H15.9375V14.8086C15.9375 15.4311 15.4311 15.9375 14.8086 15.9375Z' fill={fill} />
        </svg>
    );
};

// CalendarIcon.propTypes = {};

export default CalendarIcon;
